import { HttpHeaders } from "@angular/common/http";

export const headersBase = () => {
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  var header = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + currentUser["token"]
    })
  };
  return header;
}
